import React from 'react'
import classnames from 'utils/classnames'

const Container = ({ children, className, ...rest }) => {
    const classNames = classnames('container mx-auto', className);

    return (
        <div className={classNames} {...rest}>
            { children }
        </div>
    )
}

export default Container